// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.referenceReplacementDocument .borderContent label[for='description'] {
  color: #262626;
  opacity: 0.65;
  font-size: 14px;
  font-weight: bold;
}
.referenceReplacementDocument .borderContent .k-textbox {
  display: block;
  position: static;
  width: 100%;
  border: 1px solid rgba(38, 38, 38, 0.3);
  border-radius: 8px;
  background: #f8f7f3;
  margin-top: 4px;
  margin-bottom: 6px;
}
.referenceReplacementDocument .borderContent .fileUploadField {
  display: block;
  float: none;
  width: unset;
}
.referenceReplacementDocument .borderContent .error {
  text-align: left;
  padding: 0;
}
`, "",{"version":3,"sources":["webpack://./src/appComponents/common/ReferenceReplacementDocument.less"],"names":[],"mappings":"AAEA;EAGG,cAAA;EACA,aAAA;EACA,eAAA;EACA,iBAAA;AAHH;AAHA;EAUG,cAAA;EACA,gBAAA;EACA,WAAA;EACA,uCAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;AAJH;AAbA;EAqBG,cAAA;EACA,WAAA;EACA,YAAA;AALH;AAlBA;EA2BG,gBAAA;EACA,UAAA;AANH","sourcesContent":["@import (reference) '../constants.less';\n\n.referenceReplacementDocument {\n\t.borderContent {\n\t\tlabel[for='description'] {\n\t\t\tcolor: @grey26;\n\t\t\topacity: 0.65;\n\t\t\tfont-size: 14px;\n\t\t\tfont-weight: bold;\n\t\t}\n\n\t\t.k-textbox {\n\t\t\tdisplay: block;\n\t\t\tposition: static;\n\t\t\twidth: 100%;\n\t\t\tborder: @fieldBorder;\n\t\t\tborder-radius: 8px;\n\t\t\tbackground: @fieldBackgroundWhite;\n\t\t\tmargin-top: 4px;\n\t\t\tmargin-bottom: 6px;\n\t\t}\n\n\t\t.fileUploadField {\n\t\t\tdisplay: block;\n\t\t\tfloat: none;\n\t\t\twidth: unset;\n\t\t}\n\n\t\t.error {\n\t\t\ttext-align: left;\n\t\t\tpadding: 0;\n\t\t}\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
